// extracted by mini-css-extract-plugin
export default {"baseImage":"BaseImage_baseImage__Ie7UT","padding":"BaseImage_padding__39O8w","background":"BaseImage_background__1pieY"};